var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_Download",
    transform: "translate(-114.557 -227.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47561",
    "data-name": "Path 47561",
    d: "M128.671,233.691l-4.869,4.847a.257.257,0,0,1-.36,0l-4.907-4.813a.248.248,0,0,1,0-.354l1.136-1.152a.258.258,0,0,1,.362,0l2.492,2.434v-6.958a.253.253,0,0,1,.253-.252l1.628-.01a.254.254,0,0,1,.257.251l.023,6.964,2.461-2.432a.256.256,0,0,1,.357,0l1.166,1.123A.249.249,0,0,1,128.671,233.691Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25239",
    "data-name": "Group 25239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25238",
    "data-name": "Group 25238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46250",
    "data-name": "Path 46250",
    d: "M132.029,237.177h-2.11a.523.523,0,0,0-.527.521h0v2.6H117.72v-2.6a.524.524,0,0,0-.527-.521h-2.11a.523.523,0,0,0-.527.521h0v4.169a1.574,1.574,0,0,0,1.582,1.563h14.836a1.575,1.575,0,0,0,1.582-1.563V237.7a.524.524,0,0,0-.527-.521Z",
    fill: "#999"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_download.9ba87f69718028340ae5b465ec540413.svg";